// extracted by mini-css-extract-plugin
module.exports = {"logo":"styles_logo__4SwJu","nameContainer":"styles_nameContainer__z0ZqT"};